import React, { useState, useEffect, useCallback } from 'react';
import { Grid, Typography, Box, Paper } from '@material-ui/core';

import TableGrid from './TableGrid';
import { Snackbar } from 'components';

import api from 'services/api';
import { mapRequests } from './requestMapper';
import { format } from 'date-fns';
import { parseISO } from 'date-fns';
import { RequestProductList } from './RequestProductList';

export default function Requests() {
  const [requests, setRequests] = useState();
  const [selectedRequestId, setSelectedRequestId] = useState();

  const fetchRequests = useCallback(async () => {
    try {
      var result = await api.get('/requests');

      for (var i = 0; i < result.data.length; i++) {
        if (result.data[i].request_type_id === 1) {
          result.data[i].request_type_name = 'Local';
        } else if (result.data[i].request_type_id === 2) {
          result.data[i].request_type_name = 'Entrega';
        } else if (result.data[i].request_type_id === 3) {
          result.data[i].request_type_name = 'Retirada';
        }

        const dataCad = format(
          parseISO(result.data[i].created_at),
          'dd/MM/yyyy HH:mm',
        );
        result.data[i].created_at = dataCad;
      }

      const dataStatus = mapRequests(result.data);
      setRequests(dataStatus);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const automaticLoadRequest = () => {
    setInterval(fetchRequests, 60000);
  };

  useEffect(() => {
    fetchRequests();
    automaticLoadRequest();
  }, [fetchRequests]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4" component="h4">
            Pedidos
          </Typography>
        </Grid>
        <Grid item md={6} xs={12}>
          <Paper elevation={1} component={Box} p={1}>
            <Box p={1} display="flex">
              <Typography variant="h6" component="h6">
                Pedidos Ativos
              </Typography>
            </Box>

            <TableGrid rows={requests} onSelect={setSelectedRequestId} />
          </Paper>
        </Grid>

        <Grid item md={6} xs={12}>
          {selectedRequestId ? (
            <RequestProductList requestId={selectedRequestId} />
          ) : null}
        </Grid>
      </Grid>
      <Snackbar />
    </>
  );
}
